export function getLimitedValue(value, outerMin, outerMax, innerMin, innerMax) {
  let min = value[0];
  let max = value[1];

  if (min > innerMax) {
    if (innerMax >= outerMin) {
      min = innerMax;
    }
  }

  if (min < outerMin) {
    min = outerMin;
  }

  if (max < min) {
    max = min;
  } else if (max < innerMin) {
    if (innerMin <= outerMax) {
      max = innerMin;
    }
  }

  if (max > outerMax) {
    max = outerMax;
  }

  return [min, max];
}
